import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/ChipGroup/chip-group';
import { css } from '@patternfly/react-styles';
import { Button } from '../Button';
import { Chip } from './Chip';
import { Tooltip } from '../Tooltip';
import TimesIcon from '@patternfly/react-icons/dist/js/icons/times-icon';
import { fillTemplate } from '../../helpers';
import { GenerateId } from '../../helpers/GenerateId/GenerateId';
export var ChipGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ChipGroup, _React$Component);

  function ChipGroup(props) {
    var _this;

    _classCallCheck(this, ChipGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ChipGroup).call(this, props));
    _this.headingRef = React.createRef();

    _this.toggleCollapse = function () {
      _this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen,
          isTooltipVisible: Boolean(_this.headingRef.current && _this.headingRef.current.offsetWidth < _this.headingRef.current.scrollWidth)
        };
      });
    };

    _this.state = {
      isOpen: _this.props.defaultIsOpen,
      isTooltipVisible: false
    };
    return _this;
  }

  _createClass(ChipGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        isTooltipVisible: Boolean(this.headingRef.current && this.headingRef.current.offsetWidth < this.headingRef.current.scrollWidth)
      });
    }
  }, {
    key: "renderLabel",
    value: function renderLabel(id) {
      var _this$props = this.props,
          categoryName = _this$props.categoryName,
          tooltipPosition = _this$props.tooltipPosition;
      var isTooltipVisible = this.state.isTooltipVisible;
      return isTooltipVisible ? React.createElement(Tooltip, {
        position: tooltipPosition,
        content: categoryName
      }, React.createElement("span", {
        tabIndex: 0,
        ref: this.headingRef,
        className: css(styles.chipGroupLabel),
        "aria-hidden": "true",
        id: id
      }, categoryName)) : React.createElement("span", {
        ref: this.headingRef,
        className: css(styles.chipGroupLabel),
        "aria-hidden": "true",
        id: id
      }, categoryName);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a = this.props,
          categoryName = _a.categoryName,
          children = _a.children,
          className = _a.className,
          isClosable = _a.isClosable,
          closeBtnAriaLabel = _a.closeBtnAriaLabel,
          ariaLabel = _a['aria-label'],
          onClick = _a.onClick,
          numChips = _a.numChips,
          expandedText = _a.expandedText,
          collapsedText = _a.collapsedText,
          defaultIsOpen = _a.defaultIsOpen,
          tooltipPosition = _a.tooltipPosition,
          rest = __rest(_a, ["categoryName", "children", "className", "isClosable", "closeBtnAriaLabel", 'aria-label', "onClick", "numChips", "expandedText", "collapsedText", "defaultIsOpen", "tooltipPosition"]);

      var isOpen = this.state.isOpen;
      var numChildren = React.Children.count(children);
      var collapsedTextResult = fillTemplate(collapsedText, {
        remaining: React.Children.count(children) - numChips
      });

      var renderChipGroup = function renderChipGroup(id) {
        var chipArray = !isOpen ? React.Children.toArray(children).slice(0, numChips) : React.Children.toArray(children);
        return React.createElement("div", {
          className: css(styles.chipGroup, className, categoryName && styles.modifiers.category)
        }, categoryName && _this2.renderLabel(id), React.createElement("ul", Object.assign({
          className: css(styles.chipGroupList)
        }, categoryName && {
          'aria-labelledby': id
        }, !categoryName && {
          'aria-label': ariaLabel
        }, {
          role: "list"
        }, rest), chipArray.map(function (child, i) {
          return React.createElement("li", {
            className: css(styles.chipGroupListItem),
            key: i
          }, child);
        }), numChildren > numChips && React.createElement("li", {
          className: css(styles.chipGroupListItem)
        }, React.createElement(Chip, {
          isOverflowChip: true,
          onClick: _this2.toggleCollapse,
          component: "button"
        }, isOpen ? expandedText : collapsedTextResult))), isClosable && React.createElement("div", {
          className: css(styles.chipGroupClose)
        }, React.createElement(Button, {
          variant: "plain",
          "aria-label": closeBtnAriaLabel,
          onClick: onClick,
          id: "remove_group_".concat(id),
          "aria-labelledby": "remove_group_".concat(id, " ").concat(id)
        }, React.createElement(TimesIcon, {
          "aria-hidden": "true"
        }))));
      };

      return numChildren === 0 ? null : React.createElement(GenerateId, null, function (randomId) {
        return renderChipGroup(_this2.props.id || randomId);
      });
    }
  }]);

  return ChipGroup;
}(React.Component);
ChipGroup.defaultProps = {
  expandedText: 'Show Less',
  collapsedText: '${remaining} more',
  categoryName: '',
  defaultIsOpen: false,
  numChips: 3,
  isClosable: false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onClick: function onClick(_e) {
    return undefined;
  },
  closeBtnAriaLabel: 'Close chip group',
  tooltipPosition: 'top',
  'aria-label': 'Chip group category'
};